export default __webpack_public_path__ + "static/Bitrate_Test_12_h264_hp_5120000-bbfff1b05bb35ddf7137484261cb0743.avif";